import { ProductVariantGroupModelType } from '@teinor/erp/types/company/product/variant/productVariantGroup';
import { TwinDictionary } from '../../../../../utils/globals/dictionary';

export const productVariantsToString = (productVariantGroup: ProductVariantGroupModelType, variantValues: TwinDictionary) => {
    const result = []
    if (variantValues && productVariantGroup?.VariantValues) {
        for (const variantValue of productVariantGroup.VariantValues) {
            result.push(variantValues[variantValue.id].name)
        }
    }
    return result.join(' - ')
}